<template>
  <el-dialog
    title="选择企业"
    :visible.sync="visible"
    width="600px"
    append-to-body=""
    @closed="handleClosed">
    <div class="search-form">
      <el-input
        v-model="config.vendorName"
        placeholder="请输入企业名称"
        style="width: 200px"
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div>
    <el-table
      v-loading="loading"
      border
      :data="list"
      @row-click="handleRowClick">
      <el-table-column
        label="企业名称"
        min-width="200"
        prop="vendorName"></el-table-column>
      <el-table-column
        label="联系人"
        prop="vendorPerson"
        min-width="90"></el-table-column>
      <el-table-column
        label="所属机构"
        prop="sgsName"
        min-width="120"></el-table-column>
      <el-table-column
        label="添加状态"
        min-width="90"
        prop="vendorAddress">
        <template slot-scope="{ row }">
          {{ row.selected ? '已添加' : '' }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      style="text-align: center;"
      :current-page="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange">
    </el-pagination>
    <div slot="footer">
      <el-button @click="visible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'WeVendorSelectModal',
  data() {
    return {
      loading: false,
      list: [],
      visible: false,
      config: { pageNum: 1, pageSize: 10, vendorName: '', appraisalOpenFlag: 0, memberFlag: 1 },
      total: 0,
      selection: []
    }
  },
  methods: {
    handleClosed() {
      this.list = []
      this.config = { ...this.config, ...this.$options.data().config }
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    handleRowClick(row) {
      const { vendorId, vendorName, selected } = row
      if (selected) {
        this.$message.error('当前企业已添加')
        return
      }
      this.$emit('select', { vendorId, vendorName })
      this.selection.push(vendorId)
      this.countSelection(this.list)
      // this.visible = false
    },
    countSelection(list) {
      const selection = this.selection
      this.list = list.map(i => ({ ...i, selected: selection.includes(i.vendorId) }))
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('account/getvendors', {
        payload: { ...this.config },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          // this.list = res.data.records
          this.countSelection(res.data.records)
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(selection = []) {
      this.selection = selection
      this.visible = true
      this.fetchList()
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
